import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import metadata from './InsuredPropertyDetailsAccordion.metadata.json5';
import styles from './InsuredPropertyDetailsAccordion.module.scss';
import messages from '../PolicyDetailsSummary/PolicyDetailsSummary.messages'
import { useTranslator } from '@jutro/locale';

function InsuredPropertyDetailsAccordion(props) {
    const { value: currentPeriodDetails, hoLobData, isDwelling,
        isTenant,
        isMH,
        isCondo } = props;
    const translator = useTranslator();

    const overrideProps = {
        structureType: {
            visible: isDwelling || isTenant
        },
        squareFootage: {
            visible: isDwelling || isTenant || isCondo
        },
        home: {
            visible: isDwelling || isTenant || isCondo
        },
        yearBuilt: {
            label: isMH ? translator(messages.modelYear) : translator(messages.yearBuilt)
        },
        numberOfStories: {
            visible: isDwelling
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={currentPeriodDetails}
            classNameMap={styles}
        />
    );
}

InsuredPropertyDetailsAccordion.propTypes = {
    value: PropTypes.shape({}),
};

InsuredPropertyDetailsAccordion.defaultProps = {
    value: {},
};

export default InsuredPropertyDetailsAccordion;
